import { ApiService } from "../index";
import { APIConfig } from "../../constants";

const LoginAPICall = (payload: any) => {
    return ApiService[APIConfig.LOGIN.METHOD](APIConfig.LOGIN.URL, payload);
}

const CheckLoginAPICall = (token: string) => {
    return ApiService[APIConfig.CHECK_LOGIN.METHOD](APIConfig.CHECK_LOGIN.URL, {}, { Authorization: "Bearer " + token });
}

const sendOtpEmail = (payload: any) => {
    return ApiService[APIConfig.SEND_OTP.METHOD](APIConfig.SEND_OTP.URL, payload);
}

const GoogleLoginAPICall = (payload: any) => {
    return ApiService[APIConfig.GOOGLE_LOGIN.METHOD](APIConfig.GOOGLE_LOGIN.URL, payload);
}

const logoutUser = (payload: any) => {
    return ApiService[APIConfig.LOGOUT.METHOD](APIConfig.LOGOUT.URL, payload);
}


const verifyOtp = (payload: any) => {
    return ApiService[APIConfig.VERIFY_OTP.METHOD](APIConfig.VERIFY_OTP.URL, payload);
}

const sendResetPasswordEmail = (payload: any) => {
    return ApiService[APIConfig.SEND_RESET_PASSWORD_EMAIL.METHOD](APIConfig.SEND_RESET_PASSWORD_EMAIL.URL, payload);
}

const resetPassword = (payload: any) => {
    return ApiService[APIConfig.RESET_PASSWORD.METHOD](APIConfig.RESET_PASSWORD.URL, payload);
}

const get_token_utilization = (payload: any) => {
    return ApiService[APIConfig.GET_TOKEN_UTILIZATION.METHOD](APIConfig.GET_TOKEN_UTILIZATION.URL, payload);
}

const create_user = (payload: any) => {
    return ApiService[APIConfig.CREATE_USER.METHOD](APIConfig.CREATE_USER.URL, payload);
}

const getAllUsersAPICall = (payload: any) => {
    // Assuming token is handled by ApiService interceptor or passed if needed
    return ApiService[APIConfig.GET_ALL_USERS.METHOD](APIConfig.GET_ALL_USERS.URL, payload);
}

const getUserTokenByIdAPICall = (payload: any) => {
    // Assuming token is handled by ApiService interceptor or passed if needed
    return ApiService[APIConfig.GET_USER_TOKEN_BY_ID.METHOD](APIConfig.GET_USER_TOKEN_BY_ID.URL, payload);
}

const addAdminSubscription = (payload: any) => {
    return ApiService[APIConfig.ADD_ADMIN_SUBSCRIPTION.METHOD](APIConfig.ADD_ADMIN_SUBSCRIPTION.URL, payload);
}

const AccountService = {
    LoginAPICall,
    CheckLoginAPICall,
    GoogleLoginAPICall,
    sendOtpEmail,
    verifyOtp,
    sendResetPasswordEmail,
    get_token_utilization,
    resetPassword,
    logoutUser,
    create_user,
    getAllUsersAPICall, // Add this
    getUserTokenByIdAPICall, // Add this
    addAdminSubscription
}

export default AccountService;
